<template>
    <div>
      <!--Navbar-->
      <div class="gw_navBarbox">
        <navBar></navBar>
      </div>
      <!--main主体部分-->
      <main>
        <router-view></router-view>
      </main>
      <!--底部-->
      <!--<footer>-->
        <!--<footerBar></footerBar>-->
      <!--</footer>-->
    </div>
</template>

<script>
  import navBar from '../components/Navbar'
  // import footerBar from '../components/footerbar'
    export default {
        name: "index",
      components: {
        navBar,
        // footerBar
      }
    }
</script>

<style scoped lang="scss">
  .gw_navBarbox{
    position: fixed;
    top:0;
    left:0;
    right:0;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue